import React from 'react'

const WhatsApp = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_835_45213)">
        <mask
          id="mask0_835_45213"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="37"
        >
          <path
            d="M17.9709 0.5C8.33216 0.5 0.518354 8.31381 0.518354 17.9525C0.518354 22.7365 3.05091 27.0124 3.05091 27.0124L0 36.3059L9.56269 33.2498C9.56269 33.2498 13.1129 35.4051 17.9709 35.4051C27.6096 35.4051 35.4234 27.5913 35.4234 17.9525C35.4234 8.31381 27.6096 0.5 17.9709 0.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_835_45213)">
          <path
            d="M30.6667 39.9417L-4.01968 30.6476L5.27445 -4.03906L39.9611 5.25507L30.6667 39.9417Z"
            fill="url(#paint0_linear_835_45213)"
          />
        </g>
        <path
          d="M17.9709 32.6127C13.4833 32.6127 9.89143 30.1876 9.89143 30.1876L4.37915 31.9863L6.16783 26.6494C6.16783 26.6494 3.31073 22.6941 3.31073 17.9525C3.31073 9.85593 9.87428 3.29238 17.9709 3.29238C26.0675 3.29238 32.6311 9.85593 32.6311 17.9525C32.6311 26.0491 26.0675 32.6127 17.9709 32.6127ZM17.9709 0.5C8.33216 0.5 0.518354 8.31381 0.518354 17.9525C0.518354 22.7365 3.05091 27.0124 3.05091 27.0124L0 36.3059L9.56269 33.2498C9.56269 33.2498 13.1129 35.4051 17.9709 35.4051C27.6096 35.4051 35.4234 27.5913 35.4234 17.9525C35.4234 8.31381 27.6096 0.5 17.9709 0.5Z"
          fill="white"
        />
        <path
          d="M26.9179 22.0904C26.9376 22.4787 27.177 23.6416 26.1407 24.7598C25.1046 25.879 22.9005 26.3968 21.8566 26.1052C20.8131 25.8137 17.3623 24.9109 15.1125 22.8126C12.8618 20.7136 11.0395 18.5043 10.294 16.8758C9.54847 15.2466 9.58989 14.2798 9.63131 13.8242C9.67272 13.3687 9.91216 11.258 11.3252 10.3537C11.3252 10.3537 11.7966 10.0547 12.0425 10.0547H13.4177C13.4177 10.0547 13.7862 10.1184 13.9551 10.5028C14.1244 10.8869 15.284 13.6107 15.3701 13.82C15.4562 14.0307 15.6814 14.5506 15.3203 15.0163C14.9592 15.4819 14.2046 16.3516 14.2046 16.3516C14.2046 16.3516 13.9056 16.6199 14.1648 17.0489C14.4233 17.4773 15.3345 18.8903 16.5255 19.9581C17.7176 21.0259 19.1762 21.8112 19.9036 22.0506C20.631 22.29 20.7905 21.971 21.0691 21.6122C21.3483 21.2537 22.2155 20.1577 22.2155 20.1577C22.2155 20.1577 22.5144 19.7187 23.1017 19.9879C23.6896 20.2571 26.5493 21.6423 26.5493 21.6423C26.5493 21.6423 26.8981 21.7018 26.9179 22.0904Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_835_45213"
          x1="13.3234"
          y1="35.2946"
          x2="22.6176"
          y2="0.608051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40BA57" />
          <stop offset="0.25" stopColor="#40BA57" />
          <stop offset="0.375" stopColor="#40BA58" />
          <stop offset="0.4375" stopColor="#40BB58" />
          <stop offset="0.5" stopColor="#41BB58" />
          <stop offset="0.53125" stopColor="#42BB59" />
          <stop offset="0.5625" stopColor="#42BB59" />
          <stop offset="0.59375" stopColor="#43BB59" />
          <stop offset="0.609375" stopColor="#44BC5A" />
          <stop offset="0.625" stopColor="#44BC5A" />
          <stop offset="0.640625" stopColor="#45BC5A" />
          <stop offset="0.65625" stopColor="#46BC5B" />
          <stop offset="0.671875" stopColor="#46BD5B" />
          <stop offset="0.6875" stopColor="#47BD5C" />
          <stop offset="0.703125" stopColor="#48BD5C" />
          <stop offset="0.710938" stopColor="#49BD5D" />
          <stop offset="0.71875" stopColor="#49BD5D" />
          <stop offset="0.726563" stopColor="#4ABE5D" />
          <stop offset="0.734375" stopColor="#4ABE5D" />
          <stop offset="0.742188" stopColor="#4BBE5E" />
          <stop offset="0.75" stopColor="#4BBE5E" />
          <stop offset="0.757813" stopColor="#4CBE5E" />
          <stop offset="0.765625" stopColor="#4CBF5F" />
          <stop offset="0.773438" stopColor="#4DBF5F" />
          <stop offset="0.78125" stopColor="#4EBF60" />
          <stop offset="0.789063" stopColor="#4EBF60" />
          <stop offset="0.796875" stopColor="#4FBF60" />
          <stop offset="0.804688" stopColor="#50C061" />
          <stop offset="0.8125" stopColor="#51C061" />
          <stop offset="0.820313" stopColor="#51C062" />
          <stop offset="0.828125" stopColor="#52C162" />
          <stop offset="0.835938" stopColor="#53C163" />
          <stop offset="0.839844" stopColor="#54C163" />
          <stop offset="0.84375" stopColor="#54C164" />
          <stop offset="0.847656" stopColor="#55C164" />
          <stop offset="0.851563" stopColor="#55C264" />
          <stop offset="0.855469" stopColor="#56C264" />
          <stop offset="0.859375" stopColor="#56C265" />
          <stop offset="0.863281" stopColor="#57C265" />
          <stop offset="0.867188" stopColor="#57C265" />
          <stop offset="0.871094" stopColor="#58C266" />
          <stop offset="0.875" stopColor="#58C366" />
          <stop offset="0.878906" stopColor="#59C366" />
          <stop offset="0.882813" stopColor="#59C367" />
          <stop offset="0.886719" stopColor="#5AC367" />
          <stop offset="0.890625" stopColor="#5AC367" />
          <stop offset="0.894531" stopColor="#5BC468" />
          <stop offset="0.898438" stopColor="#5BC468" />
          <stop offset="0.902344" stopColor="#5CC468" />
          <stop offset="0.90625" stopColor="#5DC469" />
          <stop offset="0.910156" stopColor="#5DC469" />
          <stop offset="0.914063" stopColor="#5EC56A" />
          <stop offset="0.917969" stopColor="#5EC56A" />
          <stop offset="0.921875" stopColor="#5FC56A" />
          <stop offset="0.925781" stopColor="#60C56B" />
          <stop offset="0.929688" stopColor="#60C56B" />
          <stop offset="0.933594" stopColor="#61C66C" />
          <stop offset="0.9375" stopColor="#62C66C" />
          <stop offset="0.941406" stopColor="#62C66D" />
          <stop offset="0.945313" stopColor="#63C66D" />
          <stop offset="0.949219" stopColor="#64C76E" />
          <stop offset="0.953125" stopColor="#64C76E" />
          <stop offset="0.957031" stopColor="#65C76E" />
          <stop offset="0.960938" stopColor="#66C76F" />
          <stop offset="0.96875" stopColor="#66C76F" />
          <stop offset="1" stopColor="#66C76F" />
        </linearGradient>
        <clipPath id="clip0_835_45213">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WhatsApp
